<template>
    <hdraces-frame :session="loaded ? session : null" />
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

import HdracesFrame from '../../../../common/hdraces/hdraces-frame.vue';
import menuHelper from '../../../../../helpers/menu.helper';

export default {
    name: 'virtual-sport-game-hdraces',
    components: { HdracesFrame },
    data() {
        return {
            loaded: false,
            backRoute: null,
            menuLinks: [],
            isMobile: isMobile.phone || isMobile.tablet
        };
    },
    computed: {
        game: function() {
            return this.$route.params.game;
        },
        isLoggedIn() {
            return Vue.state.player.isLoggedIn();
        },
        lang() {
            return Vue.state.lang.currentLang;
        },
        backUrl() {
            return this.backRoute ? `${window.location.protocol}//${window.location.host}${this.backRoute}` : null;
        },
        session() {
            return Vue.state.hdraces.session.get();
        }
    },
    watch: {
        async $route() {
            await this.load();
        }
    },
    async created() {
        await Vue.state.player.ensure();
        this.menuLinks = await menuHelper.getMenuLinks();
        this.backRoute = this.menuLinks.reduce((acc, item) => {
            if (item.name === 'virtual-sports') acc = '/virtual-sport';
            if (item.name === 'races') acc = '/races';

            return acc;
        }, null);
        await this.load();
    },
    methods: {
        async load() {
            this.loaded = false;

            if (this.isLoggedIn) {
                await Vue.state.hdraces.session.open(this.game, this.lang, this.isMobile, this.backUrl);
            } else {
                await Vue.state.hdraces.session.openDemo(this.game, this.lang, this.isMobile, this.backUrl);
            }

            if (this.isMobile) window.location.replace(this.session.gameUrl);

            this.loaded = true;
        }
    },
    async beforeDestroy() {
        this.loaded = false;
        
        if (this.session) {
            await Vue.state.hdraces.session.close(this.session.sessionId);
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/virtual-sports/virtual-sport-game/hdraces.vue